import { ReactComponent as UnknownCardIconSVG } from '@/assets/icons/UnknownCardIcon.svg';
import { SVGProps } from 'react';

const UnknownCardIcon = (props: SVGProps<SVGSVGElement>) => <UnknownCardIconSVG {...props} />;

export default UnknownCardIcon;
